export enum REFERENCE_MAPPINGS {
  ADDRESS_COUNTRY = 'ADDRESS_COUNTRY',
  ADDRESS_PROVINCE = 'ADDRESS_PROVINCE',
  ADDRESS_DISTRICT = 'ADDRESS_DISTRICT',
  ADDRESS_CITY = 'ADDRESS_CITY',
  ADDRESS_POSTAL_CODE = 'ADDRESS_POSTAL_CODE',
}
